import { html, ref, repeat, when } from '@microsoft/fast-element';
export const listTemplate = html `
  <div class="container">
    ${when((x) => x.enableFilterBar, html `
        <zero-filter-bar
          resource=${(x) => x.resourceName}
          only=${(x) => { var _a; return (_a = x.columns) === null || _a === void 0 ? void 0 : _a.map((colDef) => colDef.field).filter((field) => !!field); }}
          labels=${(x) => { var _a; return (_a = x.columns) === null || _a === void 0 ? void 0 : _a.map((colDef) => colDef.headerName || ''); }}
          target="datasource"
        ></zero-filter-bar>
      `)}
    <zero-grid-pro
      ${ref('grid')}
      auto-cell-renderer-by-type
      rowSelection="single"
      rowHeight="36"
      headerHeight="36"
      persist-column-state-key=${(x) => x.persistColumnStateKey}
      ?only-template-col-defs=${(x) => !!x.columns}
      readOnlyEdit="true"
      tooltipMouseTrack="true"
      tooltipShowDelay="0"
      async-add=${(x) => x.asyncAdd}
      async-remove=${(x) => x.asyncRemove}
      async-update=${(x) => x.asyncUpdate}
      enable-cell-flashing=${(x) => x.enableCellFlashing}
      enable-row-flashing=${(x) => x.enableRowFlashing}
    >
      <grid-pro-genesis-datasource
        ${ref('datasource')}
        :deferredGridOptions=${(x) => x.gridOptions}
        criteria=${(x) => { var _a; return (_a = x.datasourceConfig) === null || _a === void 0 ? void 0 : _a.criteria; }}
        fields=${(x) => { var _a; return (_a = x.datasourceConfig) === null || _a === void 0 ? void 0 : _a.fields; }}
        is-snapshot=${(x) => { var _a; return (_a = x.datasourceConfig) === null || _a === void 0 ? void 0 : _a.isSnapshot; }}
        max-rows=${(x) => { var _a; return (_a = x.datasourceConfig) === null || _a === void 0 ? void 0 : _a.maxRows; }}
        max-view=${(x) => { var _a; return (_a = x.datasourceConfig) === null || _a === void 0 ? void 0 : _a.maxView; }}
        moving-view=${(x) => { var _a; return (_a = x.datasourceConfig) === null || _a === void 0 ? void 0 : _a.movingView; }}
        order-by=${(x) => { var _a; return (_a = x.datasourceConfig) === null || _a === void 0 ? void 0 : _a.orderBy; }}
        polling-interval=${(x) => { var _a; return (_a = x.datasourceConfig) === null || _a === void 0 ? void 0 : _a.pollingInterval; }}
        resource-name=${(x) => x.resourceName}
        reverse=${(x) => { var _a; return (_a = x.datasourceConfig) === null || _a === void 0 ? void 0 : _a.reverse; }}
      ></grid-pro-genesis-datasource>
      ${repeat((x) => x.columns, html `
          <grid-pro-column :definition=${(x) => x}></grid-pro-column>
        `)}
      ${repeat((x) => x.actionButtonsConfig, html `
          <grid-pro-column :definition=${(x) => x}></grid-pro-column>
        `)}
    </zero-grid-pro>
  </div>
`;
